import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SearchBar from 'material-ui-search-bar';
import { makeStyles } from '@material-ui/styles';
import { sc } from 'src/utils/Common';
import {
  Backdrop,
  Box,
  Grid,
  Card,
  CardHeader,
  CircularProgress,
  CardContent,
  Divider,
  Container,
} from '@material-ui/core';
import Page from 'src/components/Page';
import QuestionCard from './QuestionCard';
import InformationCard from './InformationCard';
import axios from 'src/utils/axios';
import moment from 'moment';


const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  }
}));


function TechnicalKnowledgeBase() {

  const { t } = useTranslation(['Catalog']);
  const classes = useStyles();

  const [searched, setSearched] = useState('');
  const [knowledgeRows, setKnowledgeRows] = useState('');
  const [initialRows, setinitialRows] = useState('');

  const GetTechnicalKnowledgeBase = () => {
    axios
      .get(`/GetFrequentlyAskedQuestionsCatalog`)
      .then(response => {
        if (response.data.length > 0) {
          setKnowledgeRows(response.data);
          setinitialRows(response.data);
        }
      })
      .catch(error => { });
  };
  
  useEffect(() => {
    GetTechnicalKnowledgeBase();
  }, []);

  const requestSearch = (searchedVal) => {
    const filteredRows = initialRows.filter((item) => sc(
      item.Header+item.Context+(item.Type === 'Question' ? item.Answer : ''),
      searchedVal
    ));
    setKnowledgeRows(filteredRows);
  };


  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  return (
    <Page title="">
      <Backdrop className={classes.backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container>
        <Card>
          <CardHeader title={t('TechnicalKnowledgeBase')} />
          <Divider />
          <CardContent>
            <Grid
              container
              item
              justify="space-between"
              alignItems="center"
              spacing={4}
              xs={12}
              sm={6}
            >
              <Grid item xs={8} sm={10}>
                <SearchBar
                placeholder={t('lblSearch')}
                  value={searched}
                  onChange={(searchVal) => requestSearch(searchVal)}
                  onCancelSearch={() => cancelSearch()}
                />
              </Grid>
            </Grid>
            <Box mb={4}>
              <Box mb={2} />
               { knowledgeRows.length > 0 ? knowledgeRows.map(m=>(
                
                m.Type === 'Question' ?
                  <QuestionCard Header={m.Header} 
                    QuestionUser={m.QuestionedUser} QuestionDate={moment(m.QuestionAskedDate).format('YYYY-MM-DD')} Question={m.Context}
                    AnswerUser={m.AnsweredUser} AnswerDate={moment(m.QuestionAnsweredDate).format('YYYY-MM-DD')} Answer ={m.Answer}
                  /> :
                  <InformationCard Header={m.Header} 
                  QuestionUser={m.QuestionedUser} QuestionDate={moment(m.QuestionAskedDate).format('YYYY-MM-DD')} Context ={m.Context} />
               )): ''}
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default TechnicalKnowledgeBase;